import { ErrorPage } from './components/ErrorPage';
import { Landing } from './components/landing/Landing';
import AuthenticatedRoute from './AuthenticatedRoute';
import { Settings } from './components/settings/Settings';
import { ForgotPassword } from './components/form/ForgotPassword';
import { SignIn } from './components/form/SignIn';
import Register from './components/form/Register';
import { CheckIn } from './components/checkIn/CheckIn';
import { Resources } from './components/home/Resources';
import { Results } from './components/results/Results';
import { ResetPassword } from 'components/form/ResetPassword';
import { InvalidToken } from 'components/form/InvalidToken';

export const routes = [
  {
    path: '/signin',
    element: <Landing component={<SignIn />} />,
  },
  {
    path: '/register',
    element: <Landing component={<Register />} isRegister={true} />,
  },
  {
    path: '/',
    element: <AuthenticatedRoute />,
    children: [
      {
        path: '',
        element: <Resources />,
      },
      {
        path: 'checkin',
        element: <CheckIn />,
      },
      {
        path: 'settings',
        element: <Settings />,
      },
      {
        path: 'results',
        element: <Results />,
      },
    ],
    errorElement: <ErrorPage />,
  },
  {
    path: '/forgotpassword',
    element: <ForgotPassword />,
    errorElement: <ErrorPage />,
  },
  {
    path: '/passwordreset',
    element: <ResetPassword />,
    errorElement: <ErrorPage />,
  },
  {
    path: '/invalidtoken',
    element: <InvalidToken />,
    errorElement: <ErrorPage />,
  },
];
